<div class="container">
  <img class="main-avatar avatar" [ngSrc]="mainAvatarUrl" width="40" height="40" alt="main-avatar"/>
  <img class="secondary-avatar avatar" [ngSrc]="secondaryAvatarUrl" width="24" height="24" [alt]="'sec_avatar' | translate"/>
</div>
